import {IOGateway} from '@interopio/gateway';

export type Logger = ReturnType<typeof IOGateway.Logging.getLogger>;

export default function getLogger(name: string): Logger {
    return IOGateway.Logging.getLogger(`gateway.bridge.${name}`);
}
